// src/services/audio.js
export class AudioService {
  constructor() {
    this.audioContext = null
    this.audioBuffers = new Map() // Cache loaded audio files
  }

  async init() {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
    }
  }

  async loadAudioFile(url) {
    await this.init()
    
    if (this.audioBuffers.has(url)) {
      return this.audioBuffers.get(url)
    }

    try {
      const response = await fetch(url)
      const arrayBuffer = await response.arrayBuffer()
      const audioBuffer = await this.audioContext.decodeAudioData(arrayBuffer)
      this.audioBuffers.set(url, audioBuffer)
      return audioBuffer
    } catch (error) {
      console.error('Error loading audio file:', error)
      throw error
    }
  }

  async playFile(url) {
    try {
      const buffer = await this.loadAudioFile(url)
      const source = this.audioContext.createBufferSource()
      source.buffer = buffer
      source.connect(this.audioContext.destination)
      source.start(0)
      return true
    } catch (error) {
      console.error('Playback failed:', error)
      return false
    }
  }

  // Your original oscillator method
  playNotificationSound(frequency = 880, duration = 0.2) {
    this.init().then(() => {
      const oscillator = this.audioContext.createOscillator()
      const gainNode = this.audioContext.createGain()

      oscillator.connect(gainNode)
      gainNode.connect(this.audioContext.destination)

      oscillator.type = "sine"
      oscillator.frequency.value = frequency
      gainNode.gain.value = 0.1

      oscillator.start()
      oscillator.stop(this.audioContext.currentTime + duration)
    })
  }
}

export const audioService = new AudioService()